import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import HomeIcon from "@mui/icons-material/Home";
import { useTranslation } from "react-i18next";
import { useForm, Controller } from "react-hook-form";
// import { usePlacesWidget } from "react-google-autocomplete";
import { TimeLoader } from "../_components/loaders/TimeLoader";
import Autocomplete from "@mui/material/Autocomplete";
import GooglePlaceAutocomplete from "../_components/GooglePlaceAutocomplete";
import { utilities } from "@/_helpers";
const componentStyles = (theme) => ({
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  buttonIco: {
    width: 24,
    height: 24,
    marginRight: 10,
    marginTop: 7,
  },
  inputIco: {
    opacity: 0.6,
    color: "#1c355e",
    paddingRight: "5px",
  },
});
const StyledRoot = styled("div")(({ theme }) => ({
  display: "contents",
  ...Object.entries(componentStyles(theme)).reduce(
    (acc, [className, style]) => ({
      ...acc,
      [`& .${className}, &.${className}`]: style,
    }),
    {},
  ),
}));
const Address = ({ handleNext, UpdateUserInfo, setRegionId, countries }) => {
  const [showSpinner, setShowSpinner] = useState(false);
  // const [address1, setAddress1] = useState("");
  const [city, setCity] = useState("");
  const [county, setCounty] = useState("");
  const [stateShortName, seStateShortName] = useState("");
  const countryCode = sessionStorage.getItem("LSCountryCode");
  const [selectedCountry, setSelectedCountry] = useState(null);

  // will be used later
  // const [stateList, setStateList] = useState(null);
  // const [addrLine1Error, setAddrLine1Error] = useState(false);
  // const [addrLine1ErrorMessage, setAddrLine1ErrorMessage] = useState("");
  // const [googleValid, setGoogleValid] = useState(false);
  // const googleCountryCode = countryCode === "USA" ? "us" : "au";
  // const [googleCountryCode, setGoogleCountryCode] = useState(
  //   countryCode === "USA" ? "us" : "au"
  // );
  // const [disableCountryInput, setDisableCountryInput] = useState(true);
  // const { ref: materialRef } = usePlacesWidget({
  //   apiKey: process.env.REACT_APP_GOOGLE_KEY,
  //   onPlaceSelected: (place) => updateInputBoxes(place),
  //   options: {
  //     types: ["geocode"],
  //     componentRestrictions: { country: googleCountryCode },
  //   },
  //   inputAutocompleteValue: "address1",
  // });
  // const { ref: materialRef } = usePlacesWidget({
  //   apiKey: process.env.REACT_APP_GOOGLE_KEY,
  //   onPlaceSelected: (place) => updateInputBoxes(place),
  //   options: {
  //     types: ["geocode"],
  //     componentRestrictions: { country: googleCountryCode },
  //   },
  //   inputAutocompleteValue: "address1",
  // });

  // const updateInputBoxes = (data) => {

  //     let address = data["address_components"].reduce((pre, cur) => {
  //       if (cur.types.indexOf("postal_code") !== -1) {
  //         return { ...pre, zip: cur.long_name };
  //       }
  //       if (cur.types.indexOf("country") !== -1) {
  //         return { ...pre, country: cur.long_name };
  //       }
  //       if (cur.types.indexOf("administrative_area_level_1") !== -1) {
  //         return { ...pre, state: cur.long_name, stateShort: cur.short_name };
  //       }
  //       if (cur.types.indexOf("administrative_area_level_2") !== -1) {
  //         return { ...pre, county: cur.long_name };
  //       }
  //       if (cur.types.indexOf("locality") !== -1) {
  //         return { ...pre, city: cur.long_name };
  //       }
  //       if (cur.types.indexOf("neighborhood") !== -1) {
  //         return { ...pre, city: cur.long_name };
  //       }
  //       if (cur.types.indexOf("street_number") !== -1) {
  //         return { ...pre, address: cur.long_name };
  //       }
  //       if (cur.types.indexOf("route") !== -1) {
  //         return { ...pre, street: cur.long_name };
  //       }
  //       return pre;
  //     }, {});
  //     const streetAddress = data.formatted_address.split(",")[0];
  //     if (address.county === undefined) address.county = address.city;
  //     // setAddress1(streetAddress);
  //     setValue("address1", streetAddress);
  //     if (address.zip) {
  //       setValue("zip", address.zip, {
  //         shouldValidate: true,
  //       });
  //     } else {
  //       setValue("zip", address.zip);
  //     }
  //     setValue(
  //       "cityCountyState",
  //       `${address?.city ? address?.city + ", " : ""}${
  //         address?.county ? address?.county + ", " : ""
  //       }${address?.state || ""}`
  //     );
  //     setCity(address.city);
  //     setCounty(address.county);
  //     seStateShortName(address.stateShort);
  //     setAddrLine1Error(false);
  //     setAddrLine1ErrorMessage("None");
  //     setAddrLine1Error(false);
  //     setGoogleValid(true);
  //     trigger("cityCountyState");
  //   };

  const updateInputBoxes = (data) => {
    const addressComponents = utilities.normalizeAddressComponents(
      data.address_components,
    );
    let address = addressComponents.reduce((pre, cur) => {
      if (cur.types.indexOf("postal_code") !== -1) {
        return {
          ...pre,
          zip: cur.long_name,
        };
      }
      if (cur.types.indexOf("country") !== -1) {
        return {
          ...pre,
          country: cur.long_name,
        };
      }
      if (cur.types.indexOf("administrative_area_level_1") !== -1) {
        return {
          ...pre,
          state: cur.long_name,
          stateShort: cur.short_name,
        };
      }
      if (cur.types.indexOf("administrative_area_level_2") !== -1) {
        return {
          ...pre,
          county: cur.long_name,
        };
      }
      if (cur.types.indexOf("locality") !== -1) {
        return {
          ...pre,
          city: cur.long_name,
        };
      }
      if (cur.types.indexOf("neighborhood") !== -1) {
        return {
          ...pre,
          city: cur.long_name,
        };
      }
      if (cur.types.indexOf("street_number") !== -1) {
        return {
          ...pre,
          address: cur.long_name,
        };
      }
      if (cur.types.indexOf("route") !== -1) {
        return {
          ...pre,
          street: cur.long_name,
        };
      }
      return pre;
    }, {});
    const streetAddress = data.formatted_address.split(",")[0];
    if (address.county === undefined) address.county = address.city;
    // setAddress1(streetAddress);
    setValue("address1", streetAddress);
    if (address.zip) {
      setValue("zip", address.zip, {
        shouldValidate: true,
      });
    } else {
      setValue("zip", address.zip);
    }
    setValue(
      "cityCountyState",
      `${address?.city ? address?.city + ", " : ""}${address?.county ? address?.county + ", " : ""}${address?.state || ""}`,
    );
    setCity(address.city);
    setCounty(address.county);
    seStateShortName(address.stateShort);
    // setAddrLine1Error(false);
    // setAddrLine1ErrorMessage("None");
    // setAddrLine1Error(false);
    // setGoogleValid(true);
    trigger("cityCountyState");
  };
  const [disableInputs, setDisableInputs] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    trigger,
    control,
    setError,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      country: null,
    },
  });
  const { t } = useTranslation();
  const address1Value = watch("address1");
  const selectedCountryCode = selectedCountry?.code || countryCode;
  const usesZipTerminology = selectedCountryCode === "USA";
  const zipLabel = usesZipTerminology
    ? t("registration.homeZip")
    : t("registration.ausHomeZip");
  const zipRequiredMessage = usesZipTerminology
    ? t("registration.zipRequired")
    : t("registration.ausZipRequired");
  const zipInvalidMessage = usesZipTerminology
    ? t("profile.zipInvalid")
    : t("profile.ausZipInvalid");
  useEffect(() => {
    if (countryCode !== "USA") {
      // setGoogleValid(false);
      // setAddress1("");
    }
  }, []);
  const validateZip = (value) => {
    const zipValue = value?.trim();
    if (!zipValue) {
      return true;
    }
    if (selectedCountryCode === "USA" && /^[0-9]{5}$/.test(zipValue)) {
      return true;
    }
    if (
      (selectedCountryCode === "AU" ||
        selectedCountryCode === "AUS" ||
        selectedCountryCode === "NZL") &&
      /^[0-9]{4}$/.test(zipValue)
    ) {
      return true;
    }
    if (selectedCountryCode === "KOR" && /^[0-9]{5}$/.test(zipValue)) {
      return true;
    }
    if (
      selectedCountryCode === "EU" &&
      /^[a-zA-Z0-9\s-]{1,10}$/.test(zipValue)
    ) {
      return true;
    }
    return zipInvalidMessage;
  };
  const validateCityCountyState = (value) => {
    if (value) {
      const parts = value?.split(",");
      const city = parts[0]?.trim();
      const county = parts[1]?.trim();
      const state = parts[2]?.trim();
      if (city && county && state) {
        return true;
      } else if (!city && !county && !state) {
        return t("profile.stateCityCountyRequired");
      } else if (!city || !county || !state) {
        const missingFields = [];
        if (!city) missingFields.push("City");
        if (!county) missingFields.push("County");
        if (!state)
          missingFields.push(countryCode === "EU" ? "Province" : "State");
        const isRequiredMessage = missingFields.length
          ? `${missingFields.join(", ")} is required`
          : "";
        return t("profile.addressRequired", {
          addressRequired: isRequiredMessage,
        });
      }
    }
  };
  const submitAddress = (data) => {
    const address1 = address1?.trim();
    const homeAddress1 = data.address1?.trim();
    if (!address1 && !homeAddress1) {
      setError("address1", {
        type: "manual",
        message: t("registration.addressRequired"),
      });
      return;
    }
    // 1. Do we have an Address?
    // if (data.address1.length > 0) {
    // 2. Do we have a City, County, State?
    // if (googleValid) {
    setDisableInputs(true);
    setShowSpinner(true);
    let addressInformation = {
      homeAddress1: data.address1,
      homeAddress2: data.address2,
      country: countryCode === "USA" ? "USA" : data?.country?.code,
      city: city,
      county: county,
      state: stateShortName,
      zip: data.zip,
    };
    UpdateUserInfo(addressInformation);
    handleNext();
    // } else {
    //   setAddrLine1Error(true);
    //   setAddrLine1ErrorMessage("Directions");
    // }
    // } else {
    //   setAddrLine1Error(true);
    //   setAddrLine1ErrorMessage("Required");
    // }
  };
  return (
    <StyledRoot>
      <form className={"form"} onSubmit={handleSubmit(submitAddress)}>
        {countryCode !== "USA" ? (
          <Controller
            name="country"
            render={({ field: __propsField }) => {
              const props = {
                ...__propsField,
                value: __propsField.value ?? null,
              };
              return (
                <Autocomplete
                  {...props}
                  id="country"
                  options={countries?.filter(
                    (x) => x?.description !== "Canada",
                  )}
                  getOptionLabel={(option) => option?.description || ""}
                  isOptionEqualToValue={(option, value) => {
                    return value?.code == option?.code;
                  }}
                  disabled={disableInputs}
                  onChange={(_, data) => {
                    // console.log(data);
                    props.onChange(data);
                    setValue("address1", "");
                    setValue("cityCountyState", "");
                    setCity("");
                    setCounty("");
                    seStateShortName("");
                    setSelectedCountry(data);
                    if (data === null) {
                      setRegionId();
                      // setDisableCountryInput(true);
                    } else {
                      // setDisableCountryInput(false);
                      setRegionId(data.regionId);
                      // setGoogleCountryCode(data.code?.toLowerCase() || "us");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t("profile.country")}
                      size="small"
                      margin="normal"
                      fullWidth
                      variant="outlined"
                      error={!!errors.country}
                      helperText={errors.country ? errors.country.message : ""}
                      slotProps={{
                        inputLabel: {
                          shrink: true,
                        },
                      }}
                    />
                  )}
                />
              );
            }}
            control={control}
            rules={{
              required: {
                value: true,
                message: t("profile.countryRequired"),
              },
            }}
          />
        ) : (
          <></>
        )}

        {/* <TextField
        variant="outlined"
        margin="normal"
        size="small"
        fullWidth
        label={t("registration.homeAddressLine1")}
        placeholder={t("registration.homeAddressPlaceHolder")}
        name="address1"
        onChange={(event) => {
          if (event.target.value.length > 0 && googleValid === true) {
            setAddrLine1Error(false);
            setAddrLine1ErrorMessage("None");
          } else {
            setAddrLine1Error(true);
            setAddrLine1ErrorMessage(
              googleValid === true ? "Required" : "Directions"
            );
          }
          const val = event.target.value;
          setValue("address1", val);
        }}
        disabled={disableInputs || (countryCode !== "USA"? disableCountryInput:false)}
        error={!!errors.address1 || addrLine1Error}
        helperText={
          errors.address1
            ? errors.address1.message
            : addrLine1ErrorMessage === "Required"
            ? t("registration.addressRequired")
            : addrLine1ErrorMessage === "Directions"
            ? t("registration.addressDirections")
            : ""
        }
        inputRef={(ref) => {
          register({
            required: {
              value: true,
              message: t("registration.addressRequired"),
            },
          })(ref);
          materialRef.current = ref;
        }}
        InputProps={{
          startAdornment: <HomeIcon className={"inputIco"} />,
        }}
       /> */}

        <GooglePlaceAutocomplete
          name="address1"
          control={control}
          label={t("registration.homeAddressLine1")}
          startIcon={HomeIcon}
          countryCodes={
            selectedCountry
              ? selectedCountry?.code
              : countryCode === "USA"
                ? "US"
                : countryCode
          }
          onPlaceSelected={updateInputBoxes}
          // defaultValue={getValues("homeAddr1") || profile[0]?.HomeAddr1}
          // value={address1}
          value={address1Value || ""}
          errors={errors}
          rules={{
            required: {
              value: true,
              message: t("registration.addressRequired"),
            },
          }}
          onChange={(value) =>
            setValue("address1", value, {
              shouldDirty: true,
              shouldValidate: true,
            })
          }

          // required={true}
        />

        <TextField
          variant="outlined"
          margin="normal"
          size="small"
          fullWidth
          disabled={disableInputs}
          label={t("registration.homeAddressLine2")}
          name="address2"
          slotProps={{
            input: {
              startAdornment: <HomeIcon className={"inputIco"} />,
            },
            htmlInput: {
              ...register("address2", {}),
            },
          }}
        />

        <TextField
          variant="outlined"
          margin="normal"
          size="small"
          fullWidth
          required
          label={t("registration.homeCityCountyState")}
          name="cityCountyState"
          placeholder={t("registration.homeCityCountyStatePlaceHolder")}
          error={!!errors.cityCountyState}
          helperText={
            errors.cityCountyState ? errors.cityCountyState.message : ""
          }
          slotProps={{
            input: {
              startAdornment: <HomeIcon className={"inputIco"} />,
              readOnly: true,
              className: "Mui-disabled",
            },
            htmlInput: {
              ...register("cityCountyState", {
                required: {
                  value: true,
                  message: t("profile.stateCityCountyRequired"),
                },
                validate: validateCityCountyState,
              }),
            },
          }}
        />
        <TextField
          variant="outlined"
          margin="normal"
          size="small"
          fullWidth
          // required
          label={zipLabel}
          name="zip"
          disabled={disableInputs}
          error={!!errors.zip}
          helperText={errors.zip ? errors.zip.message : ""}
          slotProps={{
            input: {
              startAdornment: <HomeIcon className={"inputIco"} />,
            },
            htmlInput: {
              ...register("zip", {
                required: {
                  value: true,
                  message: zipRequiredMessage,
                },
                validate: validateZip,
              }),
            },
          }}
        />
        <Grid
          container
          sx={{
            flexDirection: "column",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          {showSpinner ? (
            <Grid
              style={{
                padding: 15,
                margin: 15,
              }}
            >
              <TimeLoader />
            </Grid>
          ) : (
            <Grid
              style={{
                paddingTop: 10,
                marginTop: 10,
                marginLeft: "-20px",
              }}
            >
              <Button
                variant="contained"
                color="primary"
                type="submit"
                style={{
                  width: 240,
                  height: 50,
                }}
              >
                {t("registration.continueFromAddress")}
              </Button>
            </Grid>
          )}
        </Grid>
      </form>
    </StyledRoot>
  );
};
Address.propTypes = {
  userInfo: PropTypes.object,
  UpdateUserInfo: PropTypes.func,
  handleNext: PropTypes.func,
  countries: PropTypes.array,
  setRegionId: PropTypes.func,
  onChange: PropTypes.func,
};
export default Address;
